import * as React from 'react';
import { useDispatch } from 'react-redux';
import { createGroup } from '../store/organization.store';
import { t } from '@moovly/i18n';
import { ModalContainer } from '@moovly/ui';
import useOrganization from '../../../hooks/useOrganization';
import { DefaultModalProps } from '../../../types/modal';

export const useCreateOrganizationGroupModal: React.FC<DefaultModalProps> = ({ closeModal, setOpen }) => {
  const { id } = useOrganization()!;
  const [name, setName] = React.useState('');
  const handleChangeName = React.useCallback((e: React.ChangeEvent<HTMLInputElement>) => setName(e.target.value), []);
  const dispatch = useDispatch<any>();
  const handleConfirm = React.useCallback(() => {
    dispatch(
      createGroup({
        name,
        organizationId: id,
      })
    );
    closeModal();
  }, [name, dispatch, id, closeModal]);
  return (
    <ModalContainer
      title={t('groups.create.title')}
      confirmButtonText={t('groups.create.button')}
      onConfirm={handleConfirm}
      setOpen={setOpen}
    >
      <form onSubmit={handleConfirm}>
        <div>
          <div className="mb-3">
            <label htmlFor="groupName" className="form-label">
              {t('groups.table.name')}
            </label>
            <input
              type="text"
              className="form-control"
              id="groupName"
              onChange={handleChangeName}
              value={name}
              autoFocus
            />
          </div>
        </div>
      </form>
    </ModalContainer>
  );
};

export default useCreateOrganizationGroupModal;
